$(function() {

  var $tellFriendModal = $('#tellFriendModal');

  if ( $tellFriendModal.length ) {
    
    // for DEV only, comment this out
    // $tellFriendModal.modal('show');

    $tellFriendModal.find('form').on( 'submit', function(e) {
      
      e.preventDefault();
      
      var $form = $(this);
      
      if ( $form.find('input[name=email]').val().trim() == '' ) {
        
        alert("Please enter an email");
      
      } else {

        $form.addClass('loading');

        // Ajax action
        $.post( '/tell-a-friend/', $form.serialize(), function( response ) {
          $form.removeClass('loading');
          if ( !response ) {
            alert("There was a server error. Please try again later or contact us.");
            return;
          }
          if ( !response.error ){
            $tellFriendModal.modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          }
          alert( response.message );
        }).fail(function() {
          $form.removeClass('loading');
          alert("There was a server error. Please try again later or contact us.");
        });

      }
    });

  }

});
